import React, { Component } from 'react';
import { notification, Input, Button, Icon, Divider, DatePicker, Spin, Pagination, Select, Modal, message, Row, Col, Form } from 'antd';
import * as actions from "../../actions/index";
import { compose } from "recompose";
import { history } from '../../container/History';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import moment from "moment"
import { withRouter } from "react-router-dom";
import InputMask from 'react-input-mask'

const FormItem = Form.Item;
const Option = Select.Option;
const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
}
class SimpleSearchClass extends Component {

    constructor(props) {
        super(props)
        this.state = {
            ...props,
            preference: { "Formula": '', "Expressions": [] },
            quicksearch: {},
            formvalues: {},
            Home_State: '',
            IsFutureDate: false,
            CustomDateErrMsg: '',
        }
    }

    states = () => {
        if (this.props.allstates) {
            let statesarray = this.props.allstates
            return statesarray.map((k, index) => {
                return (
                    <option key={k.id} value={k.name.split('-')[1]}>{k.short}</option>
                )
            })
        }
    }

    Eaglestates = () => {
        if (this.props.allstates) {
            let statesarray = this.props.allstates
            return statesarray.map((k, index) => {
                return (
                    <option key={k.id} value={k.short}>{k.short}</option>
                )
            })
        }
    }

    CheckTheDate = (value, i) => {

        console.log("CheckTheDate " + value) 
        var today = moment().format('MM/DD/YYYY'),
        enteredDate = value.split("/");

        enteredDate = new Date(enteredDate[2], enteredDate[1] - 1, enteredDate[0]).getTime();
        let isFuturedate =  moment().isBefore(value);
        let isCurrentDate = moment(today).isSame(value);

        if (isFuturedate) {
           return this.setState({
                IsFutureDate: true,
                CustomDateErrMsg: 'The date Should not be in the future!'
            })
        }
        if (isCurrentDate) {
            return  this.setState({
                IsFutureDate: true,
                CustomDateErrMsg: 'Date Of Birth should not be as a current Date!'
            })
        }
         else {
            return this.setState({
                IsFutureDate: false,
                CustomDateErrMsg: ''
            })
        }

      }

    handleSubmit = (e) => {

        e.preventDefault();
        if (!this.state.IsFutureDate) {
        this.props.form.validateFields((err, values) => {
            let IsAlumniSearch;
            (this.props.location.pathname == '/alumni-search') ? IsAlumniSearch = true : IsAlumniSearch = false
            if (!err) {
                
                /* NOTE: When searching the home state in alumni Search tab, you don't need the full name of the state to get the results.  -- AAG-686 In complete search results must be resolved */
                
                // if (values.Home_State) { 
                //     let state = this.props.allstates.filter(e => e.name.toLowerCase().includes(values.Home_State.toLowerCase()))
                //     values.Home_State = state.length != 0 ? state[0].name.split('-')[1] : values.Home_State
                // }
                // if (values.EagleScoutUnitState) {
                //     let EagleScoutState = this.props.allstates.filter(e => e.name.toLowerCase().includes(values.EagleScoutUnitState.toLowerCase()))
                //     values.EagleScoutUnitState = EagleScoutState.length != 0 ? EagleScoutState[0].name.split('-')[1] : values.EagleScoutUnitState
                // }
              
                let formula = ''
                let expressions = []
                let queryfilter = []
                let Query = ''
                let columnlist = []
                let Key_Index = ''
                var valuesKey = Object.keys(values);
                valuesKey = valuesKey.filter(e => values[e]);
                for (let i = 0; i < valuesKey.length; i++) {
                    //Add leading zeroes, when necessary, to make the searchable unit number 4 digits long 
                    if (valuesKey[i] == "EagleScoutUnitNumber") {
                        if (values[valuesKey[i]]) {
                            let unitNumber = values[valuesKey[i]]
                            while (unitNumber.length < 4) unitNumber = "0" + unitNumber;
                            values["EagleScoutUnitNumber"] = unitNumber
                        }
                    }

                    //change date format
                    if (valuesKey[i] == 'BoardOfReviewDT' || valuesKey[i] == 'DateOfBirth') {
                        if (values[valuesKey[i]] && values[valuesKey[i]] != 'Invalid date') {
                            values[valuesKey[i]] = moment(values[valuesKey[i]], "MM/DD/YYYY").format("YYYYMMDD");
                            values[valuesKey[i]] = values[valuesKey[i]] + "000000"
                        }
                    }

                    if (values[valuesKey[i]] && values[valuesKey[i]] != '' && values[valuesKey[i]] != 'Invalid date') {
                        formula += '@exp' + i + " AND "
                        expressions.push({
                            "ExpressionName": "exp" + i,
                            "ColumnName": valuesKey[i],
                            "Operator": (valuesKey[i] == 'BoardOfReviewDT' || valuesKey[i] == 'DateOfBirth' || valuesKey[i] == 'ScoutingAffiliation' || valuesKey[i] == 'FirstName' || valuesKey[i] == 'LastName' ) ? "EQ" : "START",
                            "Value": values[valuesKey[i]] ? values[valuesKey[i]] : ""
                        })
                    }

                    columnlist.push(valuesKey[i])
                }
                columnlist.push('personGUID', 'FacebookName', 'InstagramName', 'TwitterName', 'LinkedinName', 'currentcouncilnameandnumber', 'membershiptype', 'membershipstatus', 'LastName', 'home_city', 'home_state', 'EagleCouncilNameAndNumber', 'EagleScoutUnitNumber', 'EagleScoutUnitCity', 'EagleScoutUnitState', 'EagleScoutUnitType', 'councilAffiliation')

                //Removing last AND
                formula = formula.slice(0, -5);

                this.state.preference.Formula = formula
                this.state.preference.Expressions = expressions
                localStorage.setItem('QuickSearchExp', JSON.stringify(values))
                this.props.actions.savelist(this.state.preference, 'quicksearch', '4', columnlist, false, this.props.perPageSize, 1) // 1 => page
                this.props.filterColumn(columnlist)
                this.props.preference(this.state.preference)
                this.props.Removefilter()
                // this.setState({
                //     formvalues: values
                // })

                if (this.props.location.pathname == '/admin-dashboard') {
                    history.push('/quick-search')
                }
            }
        });

    }
    }

    removeFilter = () =>{
        window.location.reload();
    }


    componentDidMount = (e) => {
        this.props.actions.isadmin()
        this.props.actions.getStates()
    }
    // validateHomeState = (e) => {
    //     if (this.props.allstates) {
    //        let getState = this.props.allstates.filter(item => {
    //            item.short === e.target.value
    //         })
    //        getState.length == 0 ? alert("working " + getState.length) : alert("Not working " + getState.length)
    //     }
    // }


    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const quicksearch = this.state.quicksearch
        return (
            <div className='widget'>
                <div className='widget-container dashboard-search'>
                    <div className="widget-header">
                        <div className='title'>
                            {(this.props.location.pathname == '/alumni-search' || this.props.location.pathname == '/quick-search') ? "Alumni Search" : "Advanced Search"}
                        </div>
                        {/* {this.props.isadmin == true &&
                                <div className='setting'>
                                    <a onClick={() => history.push('/list-and-search')}><i className='fa fa-search margin-right-5'></i> Advanced Search </a>
                                </div>
                            } */}
                    </div>

                    {/* <Form className='searchform alumni-ui' onSubmit={this.handleSubmit}  {...layout}> */}
                    <Form className='searchform alumni-ui' onSubmit={this.handleSubmit} >
                        <Row className='searchwidget ' type='flex'  gutter={48}>
                            <Col span={8}>
                                <div className="sub-title" > Alumni Information</div>
                                <Row type='flex' align='middle' justify='center' >
                                    <Col className="" span={24}>
                                        <FormItem label='First Name'>
                                            {getFieldDecorator('FirstName')(
                                                <Input />
                                            )}
                                        </FormItem>
                                    </Col>
                                    <Col className="" span={24}>
                                        <FormItem label='Last Name'>
                                            {getFieldDecorator('LastName')(
                                                <Input />
                                            )}
                                        </FormItem>
                                    </Col>
                                    <Col className="" span={24}>
                                        <FormItem 
                                         hasFeedback
                                         validateStatus={this.state.IsFutureDate ? "error"  : undefined}
                                         help={this.state.CustomDateErrMsg ? this.state.CustomDateErrMsg : undefined}
                                         onBlur={(e) => this.CheckTheDate(e.target.value, 1)}
                                        label='Date of Birth'
                                        >
                                            {getFieldDecorator('DateOfBirth', {
                                                initialValue: '',
                                                rules: [
                                                //   { required: true, message: 'Enter the date of birth!' },
                                                  {
                                                    pattern:/^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
                                                    message: `Please enter correct format MM/DD/YYYY Pattern`
                                                 }
                                              ],
                                              })
                                            (
                                                // <DatePicker className='width-100' format="MM/DD/YYYY" />
                                                <InputMask
                                                    mask="99/99/9999"
                                                    placeholder='MM/DD/YYYY'
                                                    alwaysShowMask
                                                    maskChar={null}
                                                    className="ant-input width-100"
                                                    render={(ref, props) => (
                                                        <Input  />
                                                    )}
                                                />
                                            )}
                                        </FormItem>
                                    </Col>
                                    <Col className="" span={24}>
                                        <FormItem label='Current Council'>
                                            {getFieldDecorator('OwnerCouncilNameAndNumber')(
                                                <Input />
                                            )}
                                        </FormItem>
                                    </Col>
                                    <Col className="" span={24}>
                                        <FormItem label='Scouting Affiliation'>
                                            {getFieldDecorator('ScoutingAffiliation')(
                                                 <Select
                                                 showSearch
                                                 placeholder="Affiliations"
                                                 style={{ width: '100%' }}
                                             >
                                                 <Option value="Alpha Phi Omega">Alpha Phi Omega</Option>
                                                 <Option value="Alumni Association">Alumni Association</Option>
                                                 <Option value="American Wood Badge Alumni">American Wood Badge Alumni</Option>
                                                 <Option value="Charles L. Sommers Alumni Association">Charles L. Sommers Alumni Association</Option>
                                                 <Option value="National Eagle Scout Association">National Eagle Scout Association</Option>
                                                 <Option value="National Organization of Sea Scout Alumni">National Organization of Sea Scout Alumni</Option>
                                                 <Option value="Order of the Arrow Alliance">Order of the Arrow Alliance</Option>
                                                 <Option value="Philmont Staff Association">Philmont Staff Association</Option>
                                                 <Option value="SBR Staff Association">SBR Staff Association </Option>
                                                 <Option value="Sea Base Alumni & Friends">Sea Base Alumni & Friends</Option>
                                                 <Option value="Venturing Alumni">Venturing Alumni</Option>
                                             </Select>
                                            )}
                                        </FormItem>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={8}>
                                <div className="sub-title">Address Information</div>
                                <Row type='flex'  justify='center' gutter={12}>
                                    <Col className="" span={24}>
                                        <FormItem label='Address'>
                                            {getFieldDecorator('Home_AddressLine1')(
                                                <Input />
                                            )}
                                        </FormItem>
                                    </Col>
                                    <Col className="" span={24}>
                                        <FormItem label='City'>
                                            {getFieldDecorator('Home_City')(
                                                <Input />
                                            )}
                                        </FormItem>
                                    </Col>
                                    <Col className="" span={12}>
                                        <FormItem label='State'>
                                            {getFieldDecorator('Home_State',)(
                                            
                                                // <Select
                                                // suffixIcon
                                                //     // onChange={this.handleStateChange}
                                                //     showSearch
                                                //     style={{ width: '100%' }}
                                                //     placeholder="Select a State"
                                                //     optionFilterProp="children"
                                                //     filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                                // >
                                                //     {this.states()}
                                                // </Select>
                                                
                                                  <Input 
                                                  style={{textTransform: 'uppercase'}} 
                                                  maxLength={2}
                                                //   onBlur={this.validateHomeState}
                                                //   onChange={(e) => this.setState({Home_State : e.target.value.toUpperCase()})}
                                                   />
                                            )}
                                        </FormItem>
                                    </Col>
                                    <Col className="" span={12}>
                                        <FormItem label='ZIP'>
                                            {getFieldDecorator('Home_Zip5')(
                                                <Input />
                                            )}
                                        </FormItem>
                                    </Col>
                                   
                                </Row>
                            </Col>
                            <Col span={8}>
                                <div className="sub-title">Eagle Information</div>
                                <Row type='flex' align='middle' justify='center' gutter={12}>
                                    <Col className="" span={24}>
                                        <FormItem label='Eagle Council'>
                                            {getFieldDecorator('EagleCouncilNameAndNumber')(
                                                <Input />
                                            )}
                                        </FormItem>
                                    </Col>
                                    <Col className="" span={24}>
                                        <FormItem label='BOR Date'>
                                            {getFieldDecorator('BoardOfReviewDT', {
                                                initialValue: '',
                                                rules: [  
                                                    // { required: true, message: 'Enter the Board of review date!' },
                                                    {
                                                        pattern: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
                                                        message: `Please enter correct format MM/DD/YYYY Pattern`
                                                    }
                                                ],
                                            })(
                                                // <DatePicker className='width-100' format="MM/DD/YYYY" />
                                                <InputMask
                                                    mask="99/99/9999"
                                                    placeholder='MM/DD/YYYY'
                                                    alwaysShowMask
                                                    maskChar={null}
                                                    className="ant-input width-100"
                                                    render={(ref, props) => (
                                                        <Input />
                                                    )}
                                                />
                                            )}
                                        </FormItem>
                                    </Col>
                                    <Col className="" span={24}>
                                        <FormItem label='Unit Number'>
                                            {getFieldDecorator('EagleScoutUnitNumber')(
                                                <Input />
                                            )}
                                        </FormItem>
                                    </Col>
                                    <Col className="" span={12}>
                                        <FormItem label='City'>
                                            {getFieldDecorator('EagleScoutUnitCity')(
                                                <Input />
                                            )}
                                        </FormItem>
                                    </Col>
                                    <Col className="" span={12}>
                                        <FormItem label='State'>
                                            {getFieldDecorator('EagleScoutUnitState')(
                                                // <Select
                                                //     // onChange={this.handleStateChange}
                                                //     showSearch
                                                //     style={{ width: '100%' }}
                                                //     placeholder=""
                                                //     optionFilterProp="children"
                                                //     filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                                // >
                                                //     {this.Eaglestates()}
                                                // </Select>
                                                <Input 
                                                style={{textTransform: 'uppercase'}} 
                                                maxLength={2}
                                              //   onBlur={this.validateHomeState}
                                              //   onChange={(e) => this.setState({Home_State : e.target.value.toUpperCase()})}
                                                 />
                                            )}
                                        </FormItem>
                                    </Col>
                                </Row>
                            </Col>
                            {/* <Col span={8}>
                                <Divider orientation="left">NESA Information</Divider>
                                <Row type='flex' align='middle' justify='center' gutter={12}>
                                    <Col className="" span={24}>
                                        <FormItem
                                            label="NESA Membership"
                                            name="nesamembership"
                                        >
                                            <Input />
                                        </FormItem>
                                    </Col>
                                    <Col className="" span={24}>
                                        <FormItem
                                            label="NESA Expiry"
                                            name="nesaexpirydate"
                                        >
                                            <Input />
                                        </FormItem>
                                    </Col>
                                </Row>
                            </Col> */}
                        </Row>

                        {/* {formItems} */}

                        <Row gutter={48} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Col xs={14} sm={14} md={6} lg={6} xl={6}>
                                <FormItem>
                                    <Button 
                                    // type="dashed width-100  "
                                    type="primary width-100"
                                    className= 'reset-btn'
                                     onClick={this.removeFilter}>
                                        {/* <Icon type="close-circle-o" />  */}
                                        RESET
                                        </Button>
                                </FormItem>
                            </Col>
                            {/* <Col xs={23} sm={23} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 10 }}>
                                    <FormItem>
                                        <Button type="dashed" onClick={this.add} >
                                            <Icon type="plus-circle-o" /> Add Another Filter
                                        </Button>
                                    </FormItem>
                                </Col> */}
                            <Col xs={14} sm={14} md={6} lg={6} xl={6}>
                                <FormItem>
                                    <Button type="primary width-100 save-change-btn" htmlType="submit">
                                        {/* <i class="fa fa-search margin-right-5" aria-hidden="true"></i> */}
                                         SEARCH</Button>
                                </FormItem>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>
        );
    }

}



function mapStateToProps(state) {
    return {
        isadmin: state.isadminreducer.isadmin,
        allstates: state.allstatesreducer.states,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}

const SimpleSearch = Form.create()(SimpleSearchClass);


export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(SimpleSearch);


// WEBPACK FOOTER //
// ./src/components/Inc/SimpleSearch.js